// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"12":"d448fcde0cf7ac99","268":"f3452bd4295bb210"}[chunkId] + ".js";
};